module.exports = "../dist/img/mini-35.f2bf.jpg";